exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CopyTextHandler{position:fixed;z-index:-1;opacity:0}", ""]);

// exports
